// extracted by mini-css-extract-plugin
export default {"container":"style_container__4AKDs","header":"style_header__j-LSN","text":"style_text__rwdVP"};